<template>
  <div class="page">
    <PageHeader><div slot="middle">{{ $t('Notifications') }}</div></PageHeader>
    <div class="px-8">
      <div class="content-header">
        <h2 class="phone-numbers">{{ $t('Phone numbers') }}</h2>
        <div class="d-flex">
          <v-btn class="mr-2" :disabled="!hasActiveNumbers" @click="deactivateAll">{{ $t('Deactivate all') }}</v-btn>
          <v-btn color="primary" :to="{ name: 'group-notifications-new' }">{{ $t('New number') }}</v-btn>
        </div>
      </div>
    </div>
    <div class="phone-numbers-container">
      <v-menu v-for="alert in notifications" :key="alert.uuid" class="phone-number-item" offset-y>
        <template v-slot:activator="{ on }">
          <div class="phone-number-item" v-on="on">
            <div class="phone-number-header">
              <div class="phone-number-title">{{ alert.phoneNumber }}</div>
              <div :class="alert.enabled ? 'active' : 'inactive'">
                {{ alert.enabled ? $t('Active') : $t('Inactive') }}
              </div>
            </div>
          </div>
        </template>
        <v-list class="py-0">
          <v-list-item class="dropdown-item" @click="toggleAlert(alert)">{{ alert.enabled ? $t('Deactivate') : $t('Activate') }}</v-list-item>
          <v-list-item class="dropdown-item" @click="editAlert(alert)">{{ $t('Edit') }}</v-list-item>
          <v-list-item class="dropdown-item" @click="startAlertDelete(alert)">{{ $t('Delete') }}</v-list-item>
        </v-list>
        </v-menu>
      </div>

    <ConfirmationModal
      v-if="showDeleteAlertModal"
      @confirm="deleteAlert"
      @cancel="showDeleteAlertModal = false"
      :is-negative="true"
      confirm-text="Slet"
      title="Slet telefonnummer?"
    ><TrashcanInfiniteRed/></ConfirmationModal>
    </div>
</template>
<script>
import PageHeader from '@/globals/components/PageHeader.vue';
import ConfirmationModal from '@/globals/components/ConfirmationModal.vue';
import TrashcanInfiniteRed from '@/modules/svg/TrashcanInfiniteRed.vue';

export default {
  name: 'group-notifications',
  components: { TrashcanInfiniteRed, ConfirmationModal, PageHeader },
  data() {
    return {
      showDeleteAlertModal: false,
      alertToDelete: null,
    };
  },
  computed: {
    notifications() {
      return this.$Alert.all();
    },
    hasActiveNumbers() {
      return this.notifications.filter((alert) => alert.enabled).length > 0;
    },
  },
  mounted() {
    this.fetchAlerts();
  },
  methods: {
    fetchAlerts() {
      this.$Alert.api().fetchByGroupName(this.$store.state.selectedGroup);
    },
    deactivateAll() {
      this.notifications.forEach((alert) => {
        if (alert.enabled) {
          this.toggleAlert(alert);
        }
      });
    },
    toggleAlert(alert) {
      const payload = {
        tasks: [],
        enabled: !alert.enabled,
        phone: alert.phoneNumber,
        schedule: alert.schedule,
      };
      this.$Alert.api().update(alert.uuid, payload).then(() => {
        this.fetchAlerts();
      });
    },
    editAlert(alert) {
      this.$router.push({ name: 'group-notifications-edit', params: { id: alert.uuid } });
    },
    startAlertDelete(alert) {
      this.alertToDelete = alert;
      this.showDeleteAlertModal = true;
    },
    deleteAlert() {
      this.$Alert.api().remove(this.alertToDelete.uuid).then(() => {
        this.fetchAlerts();
      });
      this.showDeleteAlertModal = false;
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.phone-numbers {
  font-size: 18px;
  font-weight: bold;
  color: #707070;
}

.phone-numbers-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0 32px;
  gap: 8px;
}

.phone-number-item {
  background-color: white;
  padding: 8px;
  border-radius: 8px;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    transform: scale(1.01);
  }
}

.active {
  font-size: 12px;
  color: #0dac30;
}

.inactive {
  font-size: 12px;
  color: #FF454B;
}

.dropdown-item {
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: rgba(0,0,0, 0.1);
  }
}

@media screen and (max-width: 1024px) {
  .phone-numbers-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
